import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';

class TextareaAutosizeWrapper extends Component {
  static propTypes = {
    rows: PropTypes.number,
    placeholder: PropTypes.string,
    initialValue: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    clear: PropTypes.bool,
    onBlur: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = { value: props.initialValue || '' };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.clear && nextProps.clear) {
      this.setState({ value: nextProps.initialValue || '' });
    }
  }

  handleOnBlur = (e) => {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(e.target.value);
    }
  };

  handleOnChange = (e) => {
    this.setState({ value: e.target.value });
  };

  render() {
    const { rows, placeholder, disabled, required } = this.props;
    const { value } = this.state;
    return (
      <TextareaAutosize
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        value={value}
        onChange={(e) => this.handleOnChange(e)}
        onBlur={(e) => this.handleOnBlur(e)}
      />
    );
  }
}

export default TextareaAutosizeWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/input/TextareaAutosizeWrapper.js